import { render, staticRenderFns } from "./ServiceMoveMassiveModal.vue?vue&type=template&id=618a739c&"
import script from "./ServiceMoveMassiveModal.vue?vue&type=script&lang=js&"
export * from "./ServiceMoveMassiveModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMoveMassiveModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports